// JsFromRoutes CacheKey ea271e5e704f7a108ccf347805cf6a40
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id'),
}
